import { useMemo } from "react";
import { Add } from "@mui/icons-material";
import { Card, Grid } from "@mui/material";
import { Box, Button, DataTable, FormField, useCommonComponentContext, IPropListContainer } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import TableCell from "../../components/TableCell";

import { Mode } from "../../constants/enums";
import { Constants } from "../../constants/constants";
import { useData, useSelectData } from "../../hooks/topic/list";
import { IRequestGetPagedTopic } from "../../services/message/Topic.service";



const TopicListContainer = ({
    requestGetPaged,
    onNavigate,
    onGetPaged,
}: IPropListContainer<IRequestGetPagedTopic> & {
    organizationId?: string;
}) => {
    const Strings = useStrings();

    const { language } = useCommonComponentContext();
    const { typeData } = useSelectData();
    const { rows, model, getPaged, handleDelete, onChangeValue, onResetModel } = useData({
        requestGetPaged,
        onGetPaged,
    });

    const FilterForm = () => (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormField
                        maxLength={255}
                        label={Strings.TOPIC.SEARCH_TEXT}
                        placeholder={Strings.TOPIC.SEARCH_TEXT}
                        defaultValue={model.requestDataTemp?.searchText || ""}
                        onBlur={(value) => onChangeValue(value, "searchText")}
                    />
                </Grid>
            </Grid>
        </Box>
    );

    const columns = useMemo(
        () => [
            {
                Header: Strings.TOPIC.NAME,
                accessor: "topicName",
                width: "100px",
            },
            {
                Header: Strings.TOPIC.TYPE,
                accessor: "type",
                Cell: ({ value }: any) => <TableCell value={Number(value)} data={typeData || []} isCodeName />,
            },
            {
                Header: Strings.TOPIC.CATEGORY,
                accessor: "category",
                Cell: ({ value }: any) => (
                    <TableCell value={!Helpers.isNullOrEmpty(value?.id) ? Helpers.getDefaultValueMultiLanguage(value?.name, language) : ""} />
                ),
            },
            { Header: Strings.TOPIC.DESCRIPTION, accessor: "description" },
        ],
        [language, typeData]
    );

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
                    <Button onClick={() => onNavigate({ mode: Mode.Create })}>
                        <Add /> &nbsp; {Strings.Common.ADD_NEW}
                    </Button>
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Card>
                    <Box p={2}>
                        <DataTable
                            totalCount={model.requestData?.totalCount || 0}
                            pageNumber={model.requestData?.pageNumber || 1}
                            rowPerPage={model.requestData?.pageSize || Constants.ROW_PER_PAGE}
                            onChangePageSize={(pageSize) => getPaged({ ...model.requestData, pageSize })}
                            onChangePageNumber={(pageNumber) => getPaged({ ...model.requestData, pageNumber })}
                            //
                            searchText={model.requestData?.searchText}
                            placeholderSearch={Strings.TOPIC.SEARCH_TEXT}
                            onSearch={(val) => getPaged({ ...model.requestData, pageNumber: 1, searchText: val })}
                            onSearchChange={(value) => onChangeValue(value, "searchText")}
                            filterForm={<FilterForm />}
                            onFilter={() => getPaged({ ...model.requestDataTemp, pageNumber: 1 })}
                            onReset={() =>
                                getPaged({
                                    ...model.requestData,
                                    pageNumber: 1,
                                    searchText: "",
                                })
                            }
                            onCloseFilter={onResetModel}
                            //
                            table={{
                                columns,
                                rows,
                            }}
                            actionList={[
                                {
                                    key: "detail",
                                    iconName: "view",
                                    title: Strings.Common.VIEW_DETAIL,
                                    callback: (row: any) => onNavigate({ id: row.id, mode: Mode.View }),
                                },
                                {
                                    key: "edit",
                                    iconName: "edit",
                                    title: Strings.Common.EDIT,
                                    callback: (row: any) => onNavigate({ id: row.id, mode: Mode.Update }),
                                },
                                {
                                    key: "delete",
                                    iconName: "delete",
                                    title: Strings.Common.DELETE,
                                    callback: (row: any) => handleDelete(row),
                                },
                            ]}
                        />
                    </Box>
                </Card>
            </Grid>
        </Grid>
    );
};

export default TopicListContainer;
